import type { GetCourseDraftById200Instructor } from './getCourseDraftById200Instructor';
import type { GetCourseDraftById200Level } from './getCourseDraftById200Level';
import type { GetCourseDraftById200Price } from './getCourseDraftById200Price';
import type { GetCourseDraftById200SectionsItem } from './getCourseDraftById200SectionsItem';

/**
 * 강의 초안 상세 정보 응답
 */
export type GetCourseDraftById200 = {
  createdAt?: string;
  /** @nullable */
  description?: string | null;
  /** 강의 초안 ID */
  id: number;
  /** 기본 사용자 정보 */
  instructor?: GetCourseDraftById200Instructor;
  /** 발행 여부 (초안이므로 항상 false) */
  readonly isPublished?: boolean;
  /** @nullable */
  level?: GetCourseDraftById200Level;
  /** @nullable */
  price?: GetCourseDraftById200Price;
  /**
   * 강의 커리큘럼 섹션 목록 (상세 정보 포함)
   * @nullable
   */
  sections?: GetCourseDraftById200SectionsItem[] | null;
  /** @nullable */
  thumbnailUrl?: string | null;
  title: string;
  updatedAt?: string;
};
